var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-footer"},[_c('div',{staticClass:"pc-footer__copy"},[_vm._v("Copyright © KAYAC Inc. All Rights Reserved.")])])}]

export { render, staticRenderFns }